import { userLogout } from "actions/userActions";
import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";

interface VerificationProps {
  history?: any;
  match?: any;
}

const Verification: FC<VerificationProps> = ({ history, match }) => {
  const dispatch = useDispatch();
  const message =
    match.params.message === "success"
      ? "Berhasil diverifikasi"
      : "verified"
      ? "Akun sudah diverifikasi"
      : "Gagal dalam verifikasi";

  useEffect(() => {
    setTimeout(() => {
      dispatch(userLogout());
    }, 3000);
  }, []);

  return (
    <div className="container mb-24 lg:mb-32">
      <div className="my-20 flex flex-col items-center  leading-[115%]  md:leading-[115%]  text-neutral-900 dark:text-neutral-100 justify-center">
        <h2 className="text-3xl md:text-5xl font-semibold ">{message}</h2>
        <span className="mt-3 mb-10">Silahkan masuk kembali</span>
      </div>
    </div>
  );
};

export default Verification;
